import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// ========================================
// Βοηθητικό time input (native)
// ========================================
const TimeField = ({ value, onChange, disabled }) => {
  return (
    <input
      type="time"
      step="60"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`border rounded-md text-sm w-[130px] text-center py-1 px-2
                  focus:outline-none focus:ring-2 focus:ring-indigo-500`}
    />
  );
};

// ========================================
// Modal Επεξεργασίας / Προσθήκης Υπαλλήλου
// ========================================
const EmployeeModal = ({ isOpen, onClose, onSave, initialData }) => {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [color, setColor] = useState('#3b82f6');
  const [active, setActive] = useState(true);
  const [schedule, setSchedule] = useState([]);

  const dayNamesEl = {
    monday: 'Δευτέρα',
    tuesday: 'Τρίτη',
    wednesday: 'Τετάρτη',
    thursday: 'Πέμπτη',
    friday: 'Παρασκευή',
    saturday: 'Σάββατο',
    sunday: 'Κυριακή',
  };

  const defaultSchedule = [
    { day_of_week: 'monday', start_time: '09:00', end_time: '17:00' },
    { day_of_week: 'tuesday', start_time: '09:00', end_time: '17:00' },
    { day_of_week: 'wednesday', start_time: '09:00', end_time: '17:00' },
    { day_of_week: 'thursday', start_time: '09:00', end_time: '17:00' },
    { day_of_week: 'friday', start_time: '09:00', end_time: '17:00' },
    { day_of_week: 'saturday', start_time: '09:00', end_time: '14:00' },
    { day_of_week: 'sunday', start_time: '', end_time: '' },
  ];

  useEffect(() => {
    if (isOpen && initialData) {
      setName(initialData.name || '');
      setRole(initialData.role || '');
      setColor(initialData.color || '#3b82f6');
      setActive(initialData.active === 1);

      fetch(`https://api.remindly.gr/get-employee-schedule.php?employee_id=${initialData.id}`)
        .then(res => res.json())
        .then(data => {
  const normalized = (data.length ? data : defaultSchedule).map(d => ({
    ...d,
    start_time:
      d.start_time && d.start_time !== '00:00' && d.start_time !== '00:00:00'
        ? d.start_time
        : '',
    end_time:
      d.end_time && d.end_time !== '00:00' && d.end_time !== '00:00:00'
        ? d.end_time
        : '',
  }));
  setSchedule(normalized);
})

        .catch(() => setSchedule(defaultSchedule));
    } else if (isOpen && !initialData) {
      setName('');
      setRole('');
      setColor('#3b82f6');
      setActive(true);
      setSchedule(defaultSchedule);
    }
  }, [isOpen, initialData]);

  console.log("📦 Schedule data before submit:", schedule);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!name.trim()) return;

  const empData = {
  id: initialData?.id,
  name,
  role,
  color,
  active: active ? 1 : 0 // κρατά την πιο πρόσφατη τιμή
};

  const isEdit = !!empData.id;

  const url = isEdit
    ? 'https://api.remindly.gr/update-employee.php'
    : 'https://api.remindly.gr/add-employee.php';

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(empData),
    });
    const data = await res.json();

    if (data.success) {
      const empId = isEdit ? empData.id : data.id;

      // ✅ Normalized schedule πριν το στείλεις
      const normalizedSchedule = schedule.map(d => ({
        ...d,
        start_time:
          d.start_time && d.start_time !== '00:00' && d.start_time !== '00:00:00'
            ? d.start_time
            : '',
        end_time:
          d.end_time && d.end_time !== '00:00' && d.end_time !== '00:00:00'
            ? d.end_time
            : ''
      }));

      console.log('📤 Sending schedule payload:', normalizedSchedule);

      const scheduleRes = await fetch('https://api.remindly.gr/update-employee-schedule.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          employee_id: empId,
          schedule: normalizedSchedule
        }),
      });

      const scheduleData = await scheduleRes.json();
      console.log('📥 Schedule update response:', scheduleData);

      if (scheduleData.success) {
        toast.success(isEdit ? 'Η ενημέρωση ολοκληρώθηκε!' : 'Ο υπάλληλος προστέθηκε!');
        onSave({ ...empData, id: empId });
        onClose();
      } else {
        toast.error('❌ Πρόβλημα κατά την αποθήκευση ωραρίου.');
      }
    } else {
      toast.error('❌ Σφάλμα κατά την αποθήκευση υπαλλήλου.');
    }
  } catch (err) {
    console.error(err);
    toast.error('Αποτυχία σύνδεσης με τον server.');
  }
};


  if (!isOpen) return null;

  const isDayOff = (d) =>
  !d.start_time ||
  !d.end_time ||
  d.start_time === '00:00' ||
  d.end_time === '00:00';

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="relative w-full max-w-lg">
        <div className="bg-white rounded-lg shadow-lg p-6 overflow-y-auto max-h-[90vh]">
          <h3 className="text-lg font-semibold mb-4">
            {initialData ? 'Επεξεργασία' : 'Νέος Υπάλληλος'}
          </h3>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              placeholder="Ονοματεπώνυμο"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
            <input
              type="text"
              placeholder="Ρόλος"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full border p-2 rounded"
            />
            <div className="flex items-center gap-2">
              <span className="text-sm">Χρώμα:</span>
              <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                className="w-8 h-6 border rounded"
              />
            </div>

            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={active}
                onChange={() => setActive(!active)}
              />
              Ενεργός
            </label>

            {/* --------- Ωράριο --------- */}
            <h4 className="text-sm font-semibold mt-6">Ωράριο Εργασίας</h4>
            <p className="text-xs text-gray-500 mb-3">
              Επιλέξτε ώρες σε 24ωρη μορφή (π.χ. 09:00 – 17:00)
            </p>

            <div className="space-y-2">
{schedule.map((day, i) => {
  const dayOff = isDayOff(day);
  return (
    <div
      key={day.day_of_week}
      className={`flex flex-wrap md:flex-nowrap items-center justify-between border rounded-lg px-3 py-2 gap-2 transition-all ${
        dayOff ? 'bg-gray-100 opacity-70' : 'bg-white hover:shadow-sm'
      }`}
    >
      {/* Ημέρα */}
      <span className="w-[70px] text-sm font-medium text-gray-700">
        {dayNamesEl[day.day_of_week]}
      </span>

      {/* Ώρες */}
      <div className="flex items-center gap-2 flex-grow justify-start min-w-[220px]">
        <TimeField
          value={day.start_time}
          disabled={dayOff}
          onChange={(val) => {
            const updated = [...schedule];
            updated[i].start_time = val || '';
            setSchedule(updated);
          }}
        />
        <TimeField
          value={day.end_time}
          disabled={dayOff}
          onChange={(val) => {
            const updated = [...schedule];
            updated[i].end_time = val || '';
            setSchedule(updated);
          }}
        />
      </div>

      {/* Ρεπό */}
      <label className="flex items-center gap-1 text-sm ml-auto md:ml-2 mt-1 md:mt-0 w-full md:w-auto justify-start md:justify-end">
        <input
          type="checkbox"
          checked={dayOff}
          onChange={() => {
            const updated = [...schedule];
            if (dayOff) {
              updated[i].start_time = '09:00';
              updated[i].end_time = '17:00';
            } else {
              updated[i].start_time = '';
              updated[i].end_time = '';
            }
            setSchedule(updated);
          }}
        />
        Ρεπό
      </label>
    </div>
  );
})}



            </div>

            <div className="flex justify-end gap-2 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-3 py-1 text-sm bg-gray-200 hover:bg-gray-300 rounded"
              >
                Άκυρο
              </button>
              <button
                type="submit"
                className="px-4 py-1 text-sm bg-indigo-600 text-white rounded hover:bg-indigo-700"
              >
                Αποθήκευση
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// ========================================
// Κύρια λίστα υπαλλήλων
// ========================================
const Employees = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetch('https://api.remindly.gr/get-employees.php', { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setEmployees(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Σφάλμα:', err);
        setLoading(false);
      });
  }, []);

  const handleSave = (updated) => {
    if (updated.id) {
      setEmployees(prev =>
        prev.map(emp => (emp.id === updated.id ? { ...emp, ...updated } : emp))
      );
    } else {
      setEmployees(prev => [...prev, updated]);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Διαγραφή υπαλλήλου;')) return;
    try {
      const res = await fetch('https://api.remindly.gr/delete-employee.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        setEmployees(prev => prev.filter(emp => emp.id !== id));
        toast.success('✅ Ο υπάλληλος διαγράφηκε.');
      } else toast.error('❌ Σφάλμα διαγραφής.');
    } catch {
      toast.error('Αποτυχία σύνδεσης με τον server.');
    }
  };

  const filtered = employees.filter(e =>
    e.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-4">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-semibold">Υπάλληλοι</h2>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Αναζήτηση..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border px-2 py-1 rounded"
          />
          <button
            onClick={() => {
              setSelectedEmployee(null);
              setModalOpen(true);
            }}
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            + Νέος
          </button>
        </div>
      </div>

      {loading ? (
        <p>Φόρτωση...</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {filtered.map(emp => (
            <div key={emp.id} className="bg-white shadow rounded p-3 flex flex-col justify-between">
              <div>
                <div className="flex justify-between items-center mb-1">
                  <span className="font-medium">{emp.name}</span>
                  <span
                    className="w-4 h-4 rounded-full border"
                    style={{ background: emp.color }}
                  ></span>
                </div>
                <p className="text-sm text-gray-500">{emp.role}</p>
              </div>
              <div className="flex justify-between items-center mt-3 text-sm">
                <span className={emp.active ? 'text-green-600' : 'text-gray-400'}>
                  {emp.active ? 'Ενεργός' : 'Ανενεργός'}
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setSelectedEmployee(emp);
                      setModalOpen(true);
                    }}
                    className="text-orange-500 hover:text-orange-600"
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDelete(emp.id)}
                    className="text-gray-500 hover:text-red-600"
                  >
                    🗑
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <EmployeeModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={selectedEmployee}
      />
    </div>
  );
};

export default Employees;
